import { resolveComponent as _resolveComponent, withModifiers as _withModifiers, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-115f9178"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "details-box"
};
const _hoisted_2 = {
  class: "details-content"
};
const _hoisted_3 = {
  class: "content-box"
};
const _hoisted_4 = {
  class: "related-orders"
};
const _hoisted_5 = {
  class: "related-title"
};
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" 关联订单");
const _hoisted_7 = {
  class: "count"
};
const _hoisted_8 = {
  key: 0,
  class: "more"
};
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" 更多");
const _hoisted_10 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "icon"
}, null, -1));
const _hoisted_11 = [_hoisted_9, _hoisted_10];
const _hoisted_12 = {
  class: "order-img"
};
const _hoisted_13 = ["src"];
const _hoisted_14 = {
  class: "order-info"
};
const _hoisted_15 = {
  class: "order-title"
};
const _hoisted_16 = {
  class: "order-price"
};
const _hoisted_17 = {
  key: 1,
  class: "unlock-rewards"
};
const _hoisted_18 = {
  class: "reward-header"
};
const _hoisted_19 = {
  class: "reward-title"
};
const _hoisted_20 = /*#__PURE__*/_createTextVNode(" 解锁奖励");
const _hoisted_21 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "sub-title-line"
}, null, -1));
const _hoisted_22 = {
  class: "sub-title"
};
const _hoisted_23 = {
  class: "reward-list"
};
const _hoisted_24 = {
  class: "reward-img"
};
const _hoisted_25 = ["src"];
const _hoisted_26 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "gift-tag"
}, null, -1));
const _hoisted_27 = {
  class: "reward-info"
};
const _hoisted_28 = {
  class: "reward-title"
};
const _hoisted_29 = {
  class: "reward-status"
};
const _hoisted_30 = {
  key: 0,
  class: "reward-count"
};
const _hoisted_31 = /*#__PURE__*/_createTextVNode(" x");
const _hoisted_32 = {
  class: "count"
};
const _hoisted_33 = {
  class: "order_paper"
};
const _hoisted_34 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "订单号", -1));
const _hoisted_35 = ["copyData"];
const _hoisted_36 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "copyicon"
}, "复制", -1));
const _hoisted_37 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "下单时间", -1));
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_van_image = _resolveComponent("van-image");
  const _component_van_sticky = _resolveComponent("van-sticky");
  const _component_detailsAddress = _resolveComponent("detailsAddress");
  const _component_detailsStatus = _resolveComponent("detailsStatus");
  const _component_dialog_btn = _resolveComponent("dialog-btn");
  const _component_lockRelateOrderList = _resolveComponent("lockRelateOrderList");
  const _component_lockRelateAddressList = _resolveComponent("lockRelateAddressList");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [!$data.env.isWeixin() ? (_openBlock(), _createBlock(_component_van_sticky, {
    key: 0,
    onChange: $options.handleStickyAction
  }, {
    default: _withCtx(() => [_createElementVNode("header", {
      class: _normalizeClass([{
        'headerAndroid': $data.env.isModianAndroid()
      }, {
        'isFix': $data.isFix
      }])
    }, [_createVNode(_component_van_image, {
      class: "back-btn",
      src: _ctx.$imgUrlFilter('https://p6.moimg.net/mdwxapp/nav_back_btn.png', 32),
      onClick: _cache[0] || (_cache[0] = _withModifiers($event => _ctx.handleGoBack(), ["stop"]))
    }, null, 8, ["src"]), _createElementVNode("div", null, _toDisplayString($setup.orderInfo.status_name), 1)], 2)]),
    _: 1
  }, 8, ["onChange"])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [$setup.orderInfo && ($setup.orderInfo.delivery_info || $setup.orderInfo.address_info && $setup.orderInfo.address_info.address_mobile.length > 0) ? (_openBlock(), _createBlock(_component_detailsAddress, {
    key: 0,
    type: "product",
    orderInfo: $setup.orderInfo,
    gift_order_id: $setup.orderInfo.gift_order_id
  }, null, 8, ["orderInfo", "gift_order_id"])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_4, [_createElementVNode("div", {
    class: "related-header",
    onClick: _cache[1] || (_cache[1] = $event => $setup.orderInfo.origin_order.orders.length > 1 ? $options.viewMoreOrders() : null)
  }, [_createElementVNode("div", _hoisted_5, [_hoisted_6, _createElementVNode("span", _hoisted_7, _toDisplayString($setup.orderInfo.origin_order.num), 1)]), $setup.orderInfo.origin_order.orders.length > 1 ? (_openBlock(), _createElementBlock("div", _hoisted_8, _hoisted_11)) : _createCommentVNode("", true)]), _createElementVNode("div", {
    class: "order-list",
    onScroll: _cache[2] || (_cache[2] = (...args) => $options.handleScroll && $options.handleScroll(...args))
  }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.orderInfo.origin_order.orders, (order, index) => {
    return _openBlock(), _createElementBlock("div", {
      class: _normalizeClass(['order-item', {
        'single-order': $setup.orderInfo.origin_order.orders.length === 1
      }]),
      key: index
    }, [_createElementVNode("div", _hoisted_12, [_createElementVNode("img", {
      src: `${_ctx.$imgUrlFilter(order.show_img, 100)}`,
      alt: "商品图片"
    }, null, 8, _hoisted_13)]), _createElementVNode("div", _hoisted_14, [_createElementVNode("div", _hoisted_15, _toDisplayString(order.reward_title), 1), _createElementVNode("div", _hoisted_16, _toDisplayString(order.show_amount), 1)])], 2);
  }), 128))], 32), $setup.orderInfo.origin_order.orders.length > 1 ? (_openBlock(), _createElementBlock("div", {
    key: 0,
    class: _normalizeClass(["mask", {
      'hidden': $data.isScrollEnd
    }])
  }, null, 2)) : _createCommentVNode("", true)]), $setup.orderInfo.sku_vos && $setup.orderInfo.sku_vos.length > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_17, [_createElementVNode("div", _hoisted_18, [_createElementVNode("div", _hoisted_19, [_hoisted_20, _hoisted_21, _createElementVNode("span", _hoisted_22, _toDisplayString($options.gift_send_type), 1)])]), _createElementVNode("div", _hoisted_23, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.orderInfo.sku_vos, (reward, index) => {
    return _openBlock(), _createElementBlock("div", {
      class: "reward-item",
      key: index
    }, [_createElementVNode("div", _hoisted_24, [_createElementVNode("img", {
      src: `${_ctx.$imgUrlFilter(reward.show_img, 180)}`,
      alt: "奖励图片"
    }, null, 8, _hoisted_25), _hoisted_26]), _createElementVNode("div", _hoisted_27, [_createElementVNode("div", _hoisted_28, _toDisplayString(reward.show_name), 1), _createElementVNode("div", _hoisted_29, _toDisplayString(reward.status_name), 1)]), reward.total_num ? (_openBlock(), _createElementBlock("div", _hoisted_30, [_hoisted_31, _createElementVNode("span", _hoisted_32, _toDisplayString(reward.total_num), 1)])) : _createCommentVNode("", true)]);
  }), 128))])])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_33, [_createElementVNode("p", null, [_hoisted_34, _createElementVNode("span", {
    onClick: _cache[3] || (_cache[3] = (...args) => $options.copy && $options.copy(...args)),
    ref: "copy",
    copyData: $setup.orderInfo.gift_order_id
  }, [_createTextVNode(_toDisplayString($setup.orderInfo.gift_order_id) + " ", 1), _hoisted_36], 8, _hoisted_35)]), _createElementVNode("p", null, [_hoisted_37, _createElementVNode("span", null, _toDisplayString($setup.orderInfo.ctime), 1)])])])]), $setup.orderInfo && $setup.orderInfo.order_btns ? (_openBlock(), _createBlock(_component_detailsStatus, {
    key: 1,
    onShow_dialog: $options.show_dialog,
    butttonList: $setup.orderInfo.btn_list,
    onToOp: _cache[4] || (_cache[4] = e => $options.op(e))
  }, null, 8, ["onShow_dialog", "butttonList"])) : _createCommentVNode("", true), _createVNode(_component_dialog_btn, {
    dialog_show: $data.dialog_show,
    onToParent: $options.close_dialog,
    dialog_btn: $data.dialog_btn,
    list: true,
    onToOp: _cache[5] || (_cache[5] = e => {
      $options.op(e);
      $options.close_dialog();
    })
  }, null, 8, ["dialog_show", "onToParent", "dialog_btn"]), _createVNode(_component_lockRelateOrderList, {
    show: $data.showRelatedOrders,
    "onUpdate:show": _cache[6] || (_cache[6] = $event => $data.showRelatedOrders = $event),
    orders: $setup.orderInfo && $setup.orderInfo.origin_order ? $setup.orderInfo.origin_order.orders : []
  }, null, 8, ["show", "orders"]), _createVNode(_component_lockRelateAddressList, {
    show: $data.showAddress,
    "onUpdate:show": _cache[7] || (_cache[7] = $event => $data.showAddress = $event),
    gift_order_id: $setup.orderInfo.gift_order_id,
    onRefresh: $setup.refreshOrderDetail
  }, null, 8, ["show", "gift_order_id", "onRefresh"])]);
}